import React from 'react'

const Footer = ({ time }) => (
  <div className="foot">
    <table width="100%">
      <tbody>
        <tr>
          <td>
            <small>Summary of Collections  |  Bohol Island State University  |  www.bisu.edu.ph</small>
          </td>
          <td className="text-right">
            <small>Date Printed: <strong>{time}</strong></small>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/containers/Print/Reports/Collections/footer.js